import React from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

export function LoginButton() {
  const navigate = useNavigate();
  const oktaContext = useOktaAuth();
  if (!oktaContext) return null;

  const isAuthenticated = oktaContext.authState?.isAuthenticated;

  const onClick = () => {
    if (isAuthenticated) {
      signOut();
    } else {
      navigate('/login');
    }
  };

  const signOut = async () => {
    const postLogoutRedirectUri = `${globalThis.location.origin}/cep`;

    try {
      await oktaContext.oktaAuth.signOut({ postLogoutRedirectUri });
    } catch (err) {
      console.error('logout', err);
      throw err;
    }
  };

  return (
    <Button onClick={onClick} size="small" variant="text">
      {isAuthenticated ? 'Logout' : 'Login'}
    </Button>
  );
}
